import globals from '../../../globals/communityGlobals';
import { updateReasonStatus, createReason } from '../../../actions/areas/admin/commandActions';

const locale = globals.getAreas(['cancellationReasons', 'reasons', 'error']);

export const eventHandlers = (state, setState, auth) => {
  const refreshTable = () => setState(newState => ({ ...newState, forceReload: !state.forceReload }));
  const handleSidePanel = isOpen => setState(newState => ({ ...newState, openAddReasonPanel: isOpen }));
  const updateTableProps = (currentPage, pageSize) => setState({ ...state, currentPage, pageSize });

  return {
    locale,
    addButtonText: locale.getMsg('addButtonText'),
    refreshTable,
    handleSidePanel,
    updateReasonStatus: (reasonId, isActive) => updateReasonStatus(auth, { reasonId, isActive }, refreshTable),
    createReason: (name, reasonType) => {
      handleSidePanel(false);
      createReason(auth, { name, reasonType }, refreshTable);
    },
    updateTableProps,
  };
};
